import takeGenericPresenterLive from '@shoflo/studio-redux/actions/source/takeGenericPresenterLive';
import toggleAgoraAttendeeCameraStatus from '@shoflo/studio-redux/actions/attendee/toggleAgoraAttendeeCameraStatus';
import toggleAgoraAttendeeMuteStatus from '@shoflo/studio-redux/actions/attendee/toggleAgoraAttendeeMuteStatus';
import setProgram from 'actions/program/setProgram';

function toggledAgoraPresenterLive({ dispatch, getState }, { attendeeId }) {
  const { broadcastSources } = getState();

  const source = broadcastSources.sources.find(s => s.value === attendeeId);

  if (!!source) {
    dispatch(
      takeGenericPresenterLive(
        source,
        {},
        setProgram,
        toggleAgoraAttendeeCameraStatus,
        toggleAgoraAttendeeMuteStatus
      )
    );
  }
}

export default toggledAgoraPresenterLive;
